import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import { apiSlice } from './slices/apiSlice';
import { userApiSlice } from './slices/userApiSlice';


const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        [userApiSlice.reducerPath]: userApiSlice.reducer,
        auth: authReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // RTK Query caches responses and errors that may include non-serializable values like Blob
                ignoredPaths: [apiSlice.reducerPath],
                ignoredActions: [
                    'api/executeQuery/pending',
                    'api/executeQuery/fulfilled',
                    'api/executeQuery/rejected',
                ],
            },
        })
            .concat(apiSlice.middleware)
            .concat(userApiSlice.middleware),
    devTools: true,
});

export default store;
